<template>
  <div class="whole-div-PHG">
    <el-container class="whole-container-PHG">
      <el-header class="whole-header-PHG" width="100%" height="10%">
        <!--          欢迎第一行-->
        <div class="header-div1-PHG">
          <div class="header-div1-div1-PHG">
            <strong><span class="header-span-PHG">欢迎访问浙江纵海自动化设备有限公司!</span></strong>
          </div>
          <div class="header-div1-div2-PHG">
            <strong><span class="header-span-PHG">联系人：彭海林 电话：153-8180-0010</span></strong>
          </div>
        </div>
        <!--          导航栏-->
        <div class="header-div2-PHG">
          <div class="header-div2-div1-PHG">
            <el-menu router :default-active="this.$route.path" class="el-menu-demo" text-color="#FFFFFF" mode="horizontal"
                     background-color="blue" active-text-color="#FFFFFF">
              <el-menu-item index="/PcHomePage" class="el-menu-item-class">
                <span class="header-span2-PHG">网站首页</span>
              </el-menu-item>
              <el-menu-item index="/PcCompanyIntroduce" class="el-menu-item-class">
                <span class="header-span2-PHG">关于我们</span>
              </el-menu-item>
              <el-menu-item index="/PcProductCenter" class="el-menu-item-class">
                <span class="header-span2-PHG">产品中心</span>
              </el-menu-item>
              <el-menu-item index="/PcNewsCenter" class="el-menu-item-class">
                <span class="header-span2-PHG">新闻中心</span>
              </el-menu-item>
              <el-menu-item index="/PcContactUs" class="el-menu-item-class">
                <span class="header-span2-PHG">联系我们</span>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
      </el-header>
      <el-main class="main-PHG" width="100%" height="90%">
        <router-view></router-view>
      </el-main>
      <!--    咨询框-->
      <div class="div2-PHG" @click="openConsult">
        <img src="../../public/image/电话图标2.png" width="25px" height="25px">联系方式
      </div>
      <!--      联系方式弹出框-->
      <div v-if="this.$store.state.PcShowConsult" class="div3-PHG">
        <div class="div3-div1-PHG">
          <img src="../../public/image/图标.jpg" style="width: 100%; height: auto;border-radius: 50%;">
        </div>
        <div class="div3-div2-PHG" @click="closeConsult">×</div>
        <br><br>
        联系人：{{this.$store.state.contactIntroduce.personName}}<br>
        手机号码：{{this.$store.state.contactIntroduce.phoneNumber}}<br>
        电话号码：{{this.$store.state.contactIntroduce.telephoneNumber}}<br><br>
        <el-button v-clipboard="phoneNumber" @click="onCopySuccess" type="primary" round>复制手机号</el-button>
        <br><br>
      </div>
    </el-container>

  </div>
</template>

<script>
  import '../css/pc/PHG_PcHomePage.css'
  export default {
    name: "PcHomePage",
    data() {
      return {
        phoneNumber:'15381800010',
        timeOpen: 0,
        timer: null,
      }
    },
    mounted() {
      this.timer = setInterval(() => {
        this.timeOpen++;
        if (this.timeOpen == 10) {
          this.$store.state.PcShowConsult = true;
        }
      }, 1000);

    },
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    methods: {
      onCopySuccess(){
        this.$message({
          message:'成功将 '+this.phoneNumber+' 复制到粘贴板!',
          type:'success',
        });
      },
      // 打开咨询弹出框
      openConsult(){
        this.$store.state.PcShowConsult = true;
      },
      //关闭咨询弹出框
      closeConsult() {
        this.$store.state.PcShowConsult = false;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/computer/PcHomePage.vue